var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable */
import React, { useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { pdfjs } from 'react-pdf';
import { ToastContainer, toast } from 'react-toastify';
import Webcam from "react-webcam";
import * as faceapi from 'face-api.js';
import { isIOS } from 'react-device-detect';
import TopNavigation from '../TopNavigation';
import Service from '../../services/Service';
import * as FormActions from '../../store/form/actions';
import * as LoaderActions from '../../store/loader/actions';
import { useTranslation } from '../../i18n';
import { Container, StartButton, SelfieMargin, SelfieMarginContainer, SelfiePreviewImg, SelfiePreviewContainer, CustomImageButton, ButtonContainer } from './styles';
import { CameraContainer, SubmitButton, TryAgainButton } from '../StepImage/styles';
import 'react-toastify/dist/ReactToastify.css';
import ImageUtils from '../../util/image-processing.util';
var width = window.innerWidth;
var height = window.innerHeight * 0.88;
var marginStyle = {
    width: window.innerWidth / 1.5,
    height: window.innerWidth,
};
var fileFormats = {
    "image/png": "png",
    "image/jpg": "jpg",
    "image/jpeg": "jpeg",
    "application/pdf": "pdf",
};
var videoConstraints = {
    width: { ideal: 1280 },
    height: { ideal: 720 },
    facingMode: 'user',
};
var StepSelfie = function (_a) {
    var _b, _c, _d;
    var step = _a.step;
    var _e = useSelector(function (state) { return state.form; }), form = _e.form, formInfo = _e.formInfo;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var _f = useState(false), loading = _f[0], setLoading = _f[1];
    var _g = useState(null), image = _g[0], setImage = _g[1];
    var webcamRef = useRef(null);
    var topNavigationRef = useRef(null);
    var mobileView = (isMobile || window.innerWidth === 390);
    var capture = React.useCallback(function () {
        if (webcamRef && webcamRef.current) {
            var image_1 = webcamRef.current.getScreenshot();
            setImage(image_1);
        }
        ;
    }, [webcamRef]);
    var clearPhoto = function () {
        setImage(null);
    };
    var sendPhoto = function () {
        setLoading(true);
        var newForm = __assign({}, form);
        if (image) {
            newForm.steps[step].fields[0].value = image;
            newForm.steps[step].fields[0].fieldValue = image;
        }
        var params = {
            onboardingForm: {
                countSteps: newForm.countSteps,
                steps: [__assign({}, newForm.steps[step])],
            },
            tokenOnboarding: (formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding) || '',
        };
        dispatch(LoaderActions.show(true));
        Service.saveStep(params)
            .then(function (response) {
            dispatch(LoaderActions.show(false));
            if (response) {
                dispatch(FormActions.addFormStep(response));
                var newStep = response.steps[0].step;
                navigate('/form', { state: { step: newStep } });
                setImage(null);
                setLoading(false);
            }
        })
            .catch(function () {
            dispatch(LoaderActions.show(false));
            setImage(null);
            setLoading(false);
        });
    };
    var convertToBase64 = function (file) {
        return new Promise(function (resolve, reject) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function () {
                if (typeof fileReader.result === 'string') {
                    resolve(fileReader.result);
                }
                else {
                    reject(new Error('File reading failed'));
                }
            };
            fileReader.onerror = function (error) {
                reject(error);
            };
        });
    };
    var convertPdfToImages = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var pdf, canvas, page, viewport, context, base64Image, img;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, pdfjs.getDocument(data).promise];
                case 1:
                    pdf = _a.sent();
                    canvas = document.createElement("canvas");
                    return [4 /*yield*/, pdf.getPage(1)];
                case 2:
                    page = _a.sent();
                    viewport = page.getViewport({ scale: 2 });
                    context = canvas.getContext("2d");
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    return [4 /*yield*/, page.render({ canvasContext: context, viewport: viewport }).promise];
                case 3:
                    _a.sent();
                    base64Image = canvas.toDataURL();
                    img = new Image();
                    img.src = base64Image;
                    img.onload = function () { return __awaiter(void 0, void 0, void 0, function () {
                        var canvas, cnv;
                        return __generator(this, function (_a) {
                            canvas = document.createElement('canvas');
                            cnv = canvas.getContext('2d');
                            canvas.width = img.naturalWidth;
                            canvas.height = img.naturalHeight;
                            if (cnv)
                                cnv.drawImage(img, 0, 0);
                            setImage(base64Image);
                            return [2 /*return*/];
                        });
                    }); };
                    canvas.remove();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleFile = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var fileInput, file, base64_1, img, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    fileInput = e.target;
                    file = (_a = fileInput.files) === null || _a === void 0 ? void 0 : _a[0];
                    if (file && !((_c = (_b = form.steps[step]) === null || _b === void 0 ? void 0 : _b.fields[0].uploads) === null || _c === void 0 ? void 0 : _c.includes(fileFormats[file.type]))) {
                        toast.dismiss();
                        toast.error(t('camera.invalidFormat'), {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                        });
                        fileInput.value = '';
                        return [2 /*return*/];
                    }
                    if (!file) return [3 /*break*/, 9];
                    setLoading(true);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 7, 8, 9]);
                    return [4 /*yield*/, convertToBase64(file)];
                case 2:
                    base64_1 = _d.sent();
                    if (!(file.type === 'application/pdf')) return [3 /*break*/, 3];
                    convertPdfToImages(base64_1);
                    return [3 /*break*/, 6];
                case 3:
                    if (!file.type.includes('image')) return [3 /*break*/, 5];
                    return [4 /*yield*/, ImageUtils.resizeImage(base64_1, 800, 700)];
                case 4:
                    base64_1 = _d.sent();
                    _d.label = 5;
                case 5:
                    if (typeof base64_1 === 'string') {
                        img = new Image();
                        img.src = base64_1;
                        img.onload = function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                setImage(base64_1);
                                return [2 /*return*/];
                            });
                        }); };
                    }
                    _d.label = 6;
                case 6: return [3 /*break*/, 9];
                case 7:
                    error_1 = _d.sent();
                    console.error(error_1);
                    return [3 /*break*/, 9];
                case 8:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var handleVideoOnPlay = function () {
        if (!isIOS) {
            setInterval(function () { return __awaiter(void 0, void 0, void 0, function () {
                var detections;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(webcamRef && webcamRef.current && webcamRef.current.video)) return [3 /*break*/, 2];
                            return [4 /*yield*/, faceapi.detectSingleFace(webcamRef.current.video, new faceapi.TinyFaceDetectorOptions()).withFaceLandmarks()];
                        case 1:
                            detections = _a.sent();
                            if (image)
                                return [2 /*return*/];
                            if (detections &&
                                detections.detection &&
                                detections.detection.score >= 0.8 &&
                                detections.detection.relativeBox.x >= 0.2 &&
                                detections.detection.relativeBox.x <= 0.25 &&
                                detections.detection.relativeBox.y >= 0.2 &&
                                detections.detection.relativeBox.y <= 0.25) {
                                capture();
                                return [2 /*return*/];
                            }
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); }, 800);
        }
    };
    return (React.createElement(Container, null,
        React.createElement(ToastContainer, null),
        React.createElement(TopNavigation, { title: form.steps[step].showStepName ? form.steps[step].stepName : '', showLogo: true, showBackButton: form.steps[step].goBack, headerTransparent: form.steps[step].headerTransparent }),
        image ? (React.createElement(SelfiePreviewContainer, null,
            React.createElement(SelfiePreviewImg, { src: image }),
            React.createElement("div", { style: { marginTop: '24px' } },
                React.createElement(TryAgainButton, { text: t('selfie.retakePhoto'), onClick: clearPhoto, disabled: loading }),
                React.createElement(SubmitButton, { text: t('selfie.sendPhoto'), onClick: sendPhoto, disabled: loading })))) : (React.createElement(React.Fragment, null, React.createElement(CameraContainer, { retrying: false },
            React.createElement("span", { style: { color: "#000", margin: '10px 0' } },
                " ",
                t('liveness.frameFace')),
            React.createElement(Webcam, { mirrored: true, audio: false, height: height, width: width, ref: webcamRef, screenshotQuality: 1, forceScreenshotSourceSize: true, onPlay: handleVideoOnPlay, screenshotFormat: "image/jpeg", videoConstraints: videoConstraints, style: { objectFit: "cover", height: height, width: width } }),
            React.createElement(SelfieMarginContainer, null,
                React.createElement(SelfieMargin, { style: marginStyle })),
            React.createElement(ButtonContainer, { isMobile: mobileView, marginHeight: marginStyle.height, marginWidth: marginStyle.width, topNavigationHeight: ((_b = topNavigationRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0 },
                React.createElement(StartButton, { text: t('selfie.takePhoto'), onClick: capture, disabled: loading, loading: loading }),
                ((_c = form.steps[step]) === null || _c === void 0 ? void 0 : _c.fields[0]) && ((_d = form.steps[step]) === null || _d === void 0 ? void 0 : _d.fields[0].uploads) && (React.createElement(CustomImageButton, null,
                    React.createElement("input", { type: "file", accept: Object.keys(fileFormats).filter(function (a) { var _a, _b; return (_b = (_a = form.steps[step]) === null || _a === void 0 ? void 0 : _a.fields[0].uploads) === null || _b === void 0 ? void 0 : _b.includes(fileFormats[a]); }).join(', '), style: { display: 'none' }, onChange: function (e) { return handleFile(e); }, capture: false }),
                    t('selfie.searchDigitalDocument')))))))));
};
export default StepSelfie;
